import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ReactNode, useMemo } from 'react';

import { useDeviceIdList } from '@/api/deviceIdList';
import { useDevices } from '@/api/devices';
import { Null } from '@/components/Null';
import { InlineAlert, InlineAlertBody, InlineAlertPrimaryButton, InlineAlertTitle } from '@/components/ui/InlineAlert';

export type TetherInfoAlertProps = {
    title: string;
    href: string;
    actionButtonLabel?: string;
    children: ReactNode;
};

export const TetherInfoAlert = ({
    title,
    href,
    actionButtonLabel = 'View on Tether',
    children,
}: TetherInfoAlertProps) => {
    const { data: deviceIds } = useDeviceIdList();
    const { data: devicesResult } = useDevices({
        devices: deviceIds?.data?.devices ?? [],
    });
    const hasTetherDevices = useMemo(() => {
        return devicesResult?.some((device) => device.hullType === 'scout') ?? false;
    }, [devicesResult]);

    if (!hasTetherDevices) {
        return <Null data-testid="tether-info-alert-none" />;
    }

    return (
        <InlineAlert
            severity="tip"
            icon={false}
            actionButton={
                <InlineAlertPrimaryButton href={href} testid="tether-info-alert">
                    {actionButtonLabel} <OpenInNewIcon sx={{ ml: 0.5, fontSize: '1rem' }} />
                </InlineAlertPrimaryButton>
            }
        >
            <InlineAlertTitle testid="tether-info-alert">{title}</InlineAlertTitle>
            <InlineAlertBody testid="tether-info-alert">{children}</InlineAlertBody>
        </InlineAlert>
    );
};
